import { useQuery, UseQueryResult } from "react-query";
import { getWorkspaceDiagnostics } from "apps/project-iq/api";
import { IDiagnostic } from "apps/project-iq/models/IDiagnostic";

export const useWorkspaceDiagnostics = (
  workspaceId: string,
): UseQueryResult<IDiagnostic[]> => {
  return useQuery<IDiagnostic[], Error>({
    queryKey: ["workspace-diagnostics", workspaceId],
    queryFn: () => getWorkspaceDiagnostics({ workspaceId }),
    enabled: !!workspaceId,
    refetchOnWindowFocus: false,
  });
};
